import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Field } from "react-final-form";
import {
  isValidPhoneNumber,
  normalizePhone,
} from "../../../support/field-parsers";

// const normalizePhone = (value) => {
//   if (!value) return value;
//   const onlyNums = value.replace(/[^\d]/g, '');
//   if (onlyNums.length <= 3) return onlyNums;
//   if (onlyNums.length <= 7) return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 7)}`;
//   return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
// };

const PhoneField = ({ id, labelPlacement, label, placeholder, isRequired }) => {
  return (
    <Field
      name={`id_${id}`}
      type="text"
      validate={(values) => {
        if (isRequired && !values) {
          return "Required";
        }
        if (!isValidPhoneNumber(values)) {
          return "Enter valid phone number";
        }
      }}
      parse={(value) => normalizePhone(value)}
    >
      {({ input, meta }) => (
        <FormControl
          isInvalid={meta.error && meta.touched && !meta.active}
          position="relative"
        >
          {labelPlacement !== "HIDDEN" ? (
            <FormLabel htmlFor={id}>{label}</FormLabel>
          ) : null}
          <Input bg="white" {...input} placeholder={placeholder} />
          {meta.error && meta.touched && !meta.active && (
            <FormErrorMessage
              fontSize="14px"
              bg="red.500"
              color="white"
              position="absolute"
              left="0"
              right="0"
              top="100%"
              mt="0"
              px={2}
              rounded="5"
              fontWeight="bold"
            >
              {meta.error}
            </FormErrorMessage>
          )}
        </FormControl>
      )}
    </Field>
  );
};

export default PhoneField;
